import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import {
  Grid,
  Button,
  TextField,
  makeStyles,
  Typography
} from "@material-ui/core";
import Checkbox from '@mui/material/Checkbox';

import { bindActionCreators } from 'redux';

import {
  updateOpenDeviceSearchDialog,
  updateWhichDevice,
  updateSelectedDeviceForSleep
} from "actions/settings";
import { FormattedMessage, useIntl } from "react-intl";
import firebase from '../../Firebase';
import 'firebase/database';
import { MAX_LENGTH } from "common/constants";



const DeviceForSleepForm = (props) => {

  const { auth_id } = props;

  const classes = useStyles();
  const { formatMessage } = useIntl();

  const selector_selected_devices = useSelector((state) => state.envSettings.selected_device_for_sleep);

  const [listDevice, setListDevice] = useState([]);
  const [lastRowId, setLastRowId] = useState(0);


  const checkBoxRowClick = (e, index) => {
    const list = [...listDevice];
    list[index]['rowChecked'] = e.target.checked;
    setListDevice(list);
  }

  const handleInputChange = (e, index) => {
    const { name, value } = e.target;

    const list = [...listDevice];
    list[index][name] = value;
    setListDevice(list);

    //redux 동기화
    props.updateSelectedDeviceForSleep(list);//이 화면의 디바이스 리스트를 redux에 저장.
  }


  const handleAddRow = () => {

    const list = [...listDevice];
    list.push({ rowChecked: false, deviceId: '', label: '' });

    setListDevice(list);
    setLastRowId(lastRowId + 1);

    //redux 동기화
    props.updateSelectedDeviceForSleep(list);//이 화면의 디바이스 리스트를 redux에 저장.
  }


  const handleRemoveBtn = () => {
    const list = [...listDevice];
    const delete_ids = [];

    for (var i = 0; i < list.length; i++) {
      if (list[i].rowChecked == true) {
        if (list[i]._id != '') {
          delete_ids.push(list[i]._id);
        }

        list.splice(i, 1);
        i--;
      }

      setListDevice(list);

      //redux 동기화
      props.updateSelectedDeviceForSleep(list);//이 화면의 디바이스 리스트를 redux에 저장.
    }
  }


  const showChargerSearchDialog = (whichDevice) => {
    props.updateSelectedDeviceForSleep(listDevice);//이 화면의 디바이스 리스트를 redux에 저장.
    props.updateWhichDevice(whichDevice);
    props.updateOpenDeviceSearchDialog(true);
  }


  //firebase의 auth child에 등록된 수면용 디바이스 목록을 가져온다.
  const loadData = async () => {

    let list2 = [];

    if (auth_id.length == 0){
      //신규 데이터
      setListDevice(list2);
      setLastRowId(list2.length);
    }
    else {

      firebase.database().ref(`/auth/${auth_id}`).once('value').then(function (snapshot) {
        snapshot.val().listDevicesForSleep?.forEach((item, idx) => {
          list2.push({ rowChecked: false, deviceId: item.deviceId, label: item.label });
        });

        setListDevice(list2);
        setLastRowId(list2.length);
      });
    }
  }


  useEffect(() => {
    loadData();
  }, []);


  return (
    <>
      <Grid container direction="row" alignItems="center">

        <Grid container spacing={2}>
          <Grid item md={12} xs={12} style={{
            backgroundColor: 'gray',
            marginLeft: "60px",
            marginRight: "60px",
            marginBottom: "40px",
          }}>
            <Typography
              className={classes.dividerInset}
              display="block"
              variant="h4"
              fullWidth
              align="center"
            >
              <FormattedMessage color="white" id="sleepDevice" />
            </Typography>
          </Grid>
        </Grid>


        {listDevice.map((row, idx) => (
          <>
            <Grid container item md={1} xs={1} direction="column" justifyContent="flex-end">
              <Checkbox
                defaultChecked={false}
                color="primary"
                onClick={event => checkBoxRowClick(event, idx)}
                checked={row.rowChecked}
              />
            </Grid>


            <Grid container item md={2} xs={6} direction="column" justifyContent="flex-end">
              <Button
                style={{ marginRight: 10 }}
                variant="outlined"
                color="primary"
                size="large"
                onClick={() => showChargerSearchDialog(idx)}
              >
                {formatMessage({ id: 'sleepDevice' }) + '#' + (idx + 1)}
              </Button>
            </Grid>


            <Grid item md={3} xs={6}>
              <TextField
                style={{ paddingRight: 10 }}
                fullWidth
                label={formatMessage({ id: 'sleepDeviceId' })}
                // name={`sleepDeviceId${idx}`}
                name="deviceId"
                value={row.deviceId}
                variant="outlined"
                inputProps={{ maxLength: MAX_LENGTH.DEVICE_ID, readOnly: true, }}
                InputLabelProps={{ shrink: true }}
                onChange={(e) => handleInputChange(e, idx)}
              />
            </Grid>


            <Grid item md={3} xs={6}>
              <TextField
                style={{ paddingRight: 10 }}
                fullWidth
                label={formatMessage({ id: 'sleepDeviceLabel' })}
                // name="sleepDeviceLabel1"
                name="label"
                value={row.label}
                variant="outlined"
                inputProps={{ maxLength: MAX_LENGTH.DEVICE_ID, readOnly: false, }}
                InputLabelProps={{ shrink: true }}
                onChange={(e) => handleInputChange(e, idx)}

              />
            </Grid>

            <Grid item md={3} xs={12} />

            <Grid item md={12} xs={12}>
              <div className={classes.content} />
            </Grid>
          </>
        ))}


        <Grid container style={{ marginTop: 10 }}>
          <Grid item md={12} align="center">
            <Button
              style={{ marginRight: 30 }}
              variant="contained" align="center" color="default" onClick={handleAddRow}>
              <FormattedMessage id="add_row" />
            </Button>

            <Button
              style={{ marginRight: 30 }}
              variant="contained" align="center" color="default" onClick={handleRemoveBtn}>
              <FormattedMessage id="delete_selected_row" />
            </Button>
          </Grid>
        </Grid>

      </Grid>
    </>

  )
}


const mapDispatchToProps2 = dispatch => {
  return bindActionCreators({
    updateOpenDeviceSearchDialog,
    updateWhichDevice,

    updateSelectedDeviceForSleep
  }, dispatch);
};


let mapStateToProps2 = (state) => {
  return {
    settings: state.settings,
    envSettings: state.envSettings,
    user: state.user
  };
}

export default connect(
  mapStateToProps2,
  mapDispatchToProps2
)(DeviceForSleepForm);


const useStyles = makeStyles((theme) => ({
  content: {
    marginTop: theme.spacing(2),
  },
  dividerInset: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    color: '#ffffff',
  },

}));
